import angular from "angular";
import {FolderTypeCodes} from "@common/model/documentFolder";
import {Util} from "@common/util";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {CacheService} from "@common/service/cache.service";
import { IAppRootScopeService } from "@/app/app.definition";
import {CommonService} from "@common/common.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {DocumentService} from "@common/service/document.service";
import {DocumentFolderService} from "@common/itemBoard/components/itemFolder/services/documentFolder.service";



export interface IEcvPostSearchResults {
        searchText: string;
        filterFolderId:number;
        util: any;
        init(): void;
    }

    class EcvPostSearchResults implements IEcvPostSearchResults {
        searchText: string;
        filterFolderId: number;
        rlFolderType: string;
        pageSize: number;
        tableParams: any;
        searchTableParams;
        util: any;
        dataLoaded: boolean = false;
        initialLoading: boolean;
        static $inject = ["$state", "$scope", "$q", "ApiAdapterService", "NgTableParams", "CacheService", "$rootScope", "CommonService", "BroadcastService" ,"DocumentService" , "DocumentFolderService"];

        constructor(
            private $state : angular.ui.IStateService,
            private $scope : angular.IScope,
            private $q : angular.IQService,
            private $_api: JavaApiAdapterService,
            private NgTableParams,
            private $_cache: CacheService,
            private $rootScope : IAppRootScopeService,
            private CommonService : CommonService,
            private BroadcastService : BroadcastService,
            private $_document : DocumentService,
            private $_docFolderSvc : DocumentFolderService
        ) {
            this.util = Util;
            this.initialLoading = true;
            this.rlFolderType = FolderTypeCodes.RESOURCE_LIBRARY;
            const context = this;
            $scope.$on('$destroy', function () {
                context.BroadcastService.removeCallBack('update-post-search-results', context.$scope.$id);
            });
        }

        init(): void {
            this.pageSize = 10;
            this.$rootScope.mainShowLoader = false;
            this.BroadcastService.registerCallBack('update-post-search-results', this.$scope.$id, (filterFolderId) => {
                this.filterFolderId = filterFolderId;
                this.updateSearchTable();
            });
            this.updateSearchTable();
        }


        updateSearchTable(): ng.IPromise<any> {
            let deferred = this.$q.defer();
            //If searchTableParams are already there just reload the table with data
            //e.g for sorting/pagination
            if (this.searchTableParams) {
                this.searchTableParams.reload().then((s) => {
                    deferred.resolve();
                });
            } else {
                let tableParams = {
                    count: this.pageSize,
                    sorting: {lastActionTime: 'desc'}
                };
                this.searchTableParams = new this.NgTableParams(tableParams, {
                    counts: [],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: (params) => {
                        this.$rootScope.mainShowLoader = true;

                        let prms = this.getPageParams(params);
                        let password = this.$_cache.getPassword();
                        let filter = {
                            documentTypes: ["DOCUMENT"],
                            addComments: false,
                            searchRLFolderId: this.filterFolderId,
                            folderType: this.rlFolderType,
                            title: this.util.documentSearchTextEscape(this.searchText)
                        };

                        //Calling document list api for data
                        let promise = this.$_api.getPostsV2(password, prms.page, this.pageSize, filter, prms.sort).then((s) => {
                                params.total(s.totalElements);
                                this.initialLoading = false;
                                this.$rootScope.mainShowLoader = false;
                                for (let p of s.posts) {
                                    //For icon, handle the attachment object
                                    //for link post type is required and rest will be handled by extension
                                    let ext = p.filename ? this.CommonService.getExtension(p.filename.toLowerCase()) : "";
                                    p.attachment = {
                                        postType: p.postType,
                                        extension: ext
                                    }
                                    this.$_docFolderSvc.getFolderHierarchy(p.documentFolderId).then((response) =>{
                                        p.parentFolderName = response;
                                    })
                                    deferred.resolve();
                                }

                                this.dataLoaded = s.totalElements > 0;
                                return this.$q.resolve(s.posts);
                            }, e => {
                                this.$rootScope.mainShowLoader = false;
                                this.initialLoading = false;
                                console.log('error while fetching search results', e);
                            }
                        );
                        // Set the position of the right div beside the left div
                        this.$_document.SubScribeTopPosition("leftPanel-search" , "rightPanel", "#document-list .doc-search-cnt");
                        return this.$q.resolve(promise);
                    },
                });
            }
            //If the search is clicked from breadcrumb need to show the cached search
            if (this.$state.params.fromSearch) {
                this.restoreSearchResultsPagination();
            }
            return deferred.promise;

        }

        //Getting values for pagination and sorting
        getPageParams = (params) => {
            let sortObj = params._params.sorting;
            let keys = Object.keys(sortObj);
            return {
                'page': params._params.page - 1,
                'sort': {
                    sortBy: keys.toString(),
                    sortOrder: sortObj[keys[0]].toUpperCase()
                }
            };
        }

        //Save pagination and search data in cache
        //generally it will be called when user opens document from title
        saveSearchPagination = () => {
            let postSearchResults = {};
            if (this.searchTableParams) {
                postSearchResults['searchTable'] = {
                    page: this.searchTableParams.page(),
                    sort: this.searchTableParams.sorting()
                };
                postSearchResults['searchText'] = this.searchText;
                postSearchResults['folderId'] = this.filterFolderId;
            }
            this.$_cache.setPostSearchResultsDetails(postSearchResults);
        }

        //Restore pagination from cache
        //generally it will be called when from breadcrumn search is clicked
        restoreSearchResultsPagination = () => {
            let pagination = this.$_cache.getPostSearchResultsDetails();
            if (pagination) {
                if (pagination.searchTable && this.searchTableParams) {
                    this.searchTableParams.page(pagination.searchTable.page);
                    this.searchTableParams.sorting(pagination.searchTable.sort);
                    this.resetSearchResults();
                }
            }
        }

        resetSearchResults = () => {
            this.$_cache.setPostSearchResultsDetails(null);
        }

        openDocument = (documentId, postType, documentFolderId) => {
            this.saveSearchPagination();
            // For the scenario where a document name is searched in the RL module and then clicked
            this.$state.go('documents-load', {
                stateParams: {
                    documentId: documentId,
                    postType: postType,
                    fromSearch: true,
                    folderId: documentFolderId,
                },
                action: 'view-rl-document'
            });
        }
    }


    function postSearchResults(): ng.IDirective {
        return {
            restrict: 'E',
            templateUrl: 'app/common/itemBoard/components/postSearchResults/post-search-results.directive.html',
            replace: true,
            controller: EcvPostSearchResults,
            controllerAs: 'postSearchResultsVm',
            scope: true,
            bindToController: {
                'searchText': '=?',
                'filterFolderId': '=?'
            },
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPostSearchResults): void => {
                controller.init();
            }
        };
    }

    angular.module('eCareVault.common.itemBoard').directive('ecvPostSearchResults', postSearchResults);

